import { createSelector } from "reselect";

const conversionUserInfoChart = (state) => state.conversionUserInfo.item;

export const getConversionUserInfoChart = createSelector(
    conversionUserInfoChart,
    (userInfo) => {
        return Object.keys(userInfo).length ? userInfo : null;
    }
);
